import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWithAuth from './AppWithAuth';
import { installResizeObserverFix } from './utils/resizeObserverFix';

// Install ResizeObserver fix before rendering
installResizeObserverFix();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppWithAuth />
  </React.StrictMode>
);